/**
 * Whether the restaurant is taking new tables. Stored on the service document
 * as `service.acceptingNew`; documents that predate the switch have no value
 * and count as open.
 */
export function acceptsNew(service) {
  return !(service && service.service && service.service.acceptingNew === false);
}

/** A diner may continue on a table that is already active even when closed. */
export function tableBlocked(service, mesaNumber) {
  if (acceptsNew(service) || !mesaNumber) return false;
  const mesa = service.service.mesasService[mesaNumber - 1];
  return !(mesa && mesa.status);
}
